import { render, staticRenderFns } from "./promoPopup.vue?vue&type=template&id=2780d63a&"
import script from "./promoPopup.vue?vue&type=script&lang=js&"
export * from "./promoPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/one-stop-shop/one-stop-shop/one-stop-shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2780d63a')) {
      api.createRecord('2780d63a', component.options)
    } else {
      api.reload('2780d63a', component.options)
    }
    module.hot.accept("./promoPopup.vue?vue&type=template&id=2780d63a&", function () {
      api.rerender('2780d63a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/wp-content/themes/global-theme/views/blocks/promoPopup/promoPopup.vue"
export default component.exports